<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    persistent
  >
    <v-card
      rounded="lg"
      elevation="6"
    >
      <v-card-title class="text-h6 pb-2 d-flex align-center gap-2">
        <v-icon icon="mdi-merge" color="warning"></v-icon>
        Merge {{ entityName }}
      </v-card-title>

      <v-card-text>
        <div class="mb-6">
          <div class="mb-6 pa-4 bg-warning-lighten-5 rounded-lg border border-warning-lighten-3">
            <div class="d-flex gap-2 mb-2">
              <v-icon icon="mdi-alert-circle" color="warning" size="small"></v-icon>
              <p class="text-body2 text-warning-darken-2 font-weight-bold mb-0">
                Warning: Destructive Operation
              </p>
            </div>
            <p class="text-body2 text-warning-darken-1 ml-6">
              The non-survivor records will be permanently deleted from the database.
              All references will be updated to point to the survivor record.
            </p>
          </div>

          <div class="mb-6">
            <v-label class="text-subtitle2 font-weight-bold mb-3 d-block">
              Select the record to keep (survivor):
            </v-label>
            <v-radio-group v-model="selectedSurvivor" density="compact">
              <v-radio
                v-for="record in selectedRecords"
                :key="record[itemKey]"
                :value="record[itemKey]"
                :label="`${record[displayField]} (ID: ${record[itemKey]})`"
                color="primary"
              ></v-radio>
            </v-radio-group>
          </div>

          <div v-if="selectedRecords.length > 1" class="mb-4 pa-4 bg-info-lighten-5 rounded-lg border border-info-lighten-3">
            <div class="d-flex gap-2 mb-2">
              <v-icon icon="mdi-delete-multiple" color="info" size="small"></v-icon>
              <p class="text-body2 text-info-darken-2 font-weight-bold mb-0">
                Records to be deleted:
              </p>
            </div>
            <ul class="text-body2 text-info-darken-1 ml-6">
              <li
                v-for="record in selectedRecords.filter(r => r[itemKey] !== selectedSurvivor)"
                :key="record[itemKey]"
              >
                {{ record[displayField] }} (ID: {{ record[itemKey] }})
              </li>
            </ul>
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="pt-0 gap-2">
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          variant="tonal"
          @click="cancel"
          :disabled="loading"
        >
          Cancel
        </v-btn>
        <v-btn
          color="warning"
          variant="tonal"
          @click="confirmMerge"
          :disabled="!selectedSurvivor || loading"
          :loading="loading"
          prepend-icon="mdi-merge"
        >
          Merge
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MergeMasterDataDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    selectedRecords: {
      type: Array,
      default: () => []
    },
    entityName: {
      type: String,
      required: true
    },
    itemKey: {
      type: String,
      default: 'SK'
    },
    displayField: {
      type: String,
      default: 'Name'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedSurvivor: null
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  },
  watch: {
    selectedRecords(newRecords) {
      // Auto-select the first record as survivor when dialog opens
      if (newRecords.length > 0 && !this.selectedSurvivor) {
        this.selectedSurvivor = newRecords[0][this.itemKey]
      }
    },
    modelValue(isOpen) {
      // Reset selected survivor when dialog closes
      if (!isOpen) {
        this.selectedSurvivor = null
      }
    }
  },
  methods: {
    confirmMerge() {
      if (!this.selectedSurvivor) return

      const duplicateIds = this.selectedRecords
        .filter(r => r[this.itemKey] !== this.selectedSurvivor)
        .map(r => r[this.itemKey])

      this.$emit('merge', {
        survivor: this.selectedSurvivor,
        duplicates: duplicateIds
      })
    },
    cancel() {
      this.selectedSurvivor = null
      this.isOpen = false
    }
  }
}
</script>

<style scoped>
.v-card-text {
  max-height: 500px;
  overflow-y: auto;
}
</style>
